export enum BadgeType {
  NONE = "NONE",
  AVANCEMENT = "AVANCEMENT",
  RESULTAT = "RESULTAT",
  FORMATEUR = "FORMATEUR",
  MIX = "MIX",
}
